<div style="margin: 20px 20px 20px 20px">
  <div style="margin-left: 20px;margin-top: 20px;">
    Lägg till medlem till <b>{{institutionshortname}} - {{institutionname}}</b>
    <b style="font-size:14px;">{{title}}</b>
  </div>
  <br>
  <div class="row">
    <div class="col-md-6 col-lg-6 col-xl-4">
      <mat-expansion-panel [expanded]=true class="accordionmargin" style="max-width:600px;">
        <mat-expansion-panel-header [expandedHeight]="'48px'">
          <mat-panel-title>
            Lägg till medlem
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <form [formGroup]="form">
          <div class="form-row">
            <div class="form-group col-sm-8">
              <label for="startDate">
                Välj datum då medlemskapet började
              </label>
              <app-calendar [form]="form" formName="startDate"></app-calendar>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-md-12" style="background-color: rgb(161, 188, 204);color: white;font-weight:bold;border: 1px solid #F0F0F0;margin-top: 20px;margin-bottom: 20px;">Sök medlem</div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label for="institutionId">Institution</label>
                <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId">
                  <option></option>
                  <option *ngFor="let inst of institutionlist" [value]="inst.id">{{inst.shortName}} &nbsp;{{inst.name}}</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label for="memberId">
                  Medlemsnr
                </label>
                <input id="memberId" type="text" class="form-control form-control-sm" formControlName="memberId">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label for="givenName">
                  Förnamn
                </label>
                <input id="givenName" type="text" class="form-control form-control-sm" formControlName="givenName">
              </div>
              <div class="form-group col-sm-6">
                <label for="familyName">
                  Efternamn
                </label>
                <input id="familyName" type="text" class="form-control form-control-sm" formControlName="familyName">
              </div>
              <div class="form-group col-sm-12 mt-3">
                <span>
                  <button class="btn border" (click)="search()" [disabled]="!form.valid">Sök</button>
                  <button class="btn border" style="margin-left:20px;" (click)="form.reset()" [disabled]="!form.dirty">Rensa</button>

                  <button class="btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button>
                </span>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </div>
    <div class="col-lg-6 col-xl-8">
      <div class="resultdiv">
        <table *ngIf="memberlist?.length > 0" matSort (matSortChange)="sortData($event)" class="table border" matSortDisableClear=true>
          <thead role="rowgroup">
            <tr>
              <th mat-sort-header="id">Id</th>
              <th mat-sort-header="givenName">Förnamn</th>
              <th mat-sort-header="familyName">Efternamn</th>
              <th style="z-index: 10000;">Välj</th>
            </tr>
          </thead>
          <tr class="tr" *ngFor="let m of memberlist;">
            <td style="width:5%;">
              <a [routerLink]="['/memberform/id/', m.id]">{{m.id}}</a>
            </td>
            <td style="width:45%;">{{m.givenName}}</td>
            <td style="width:45%;">{{m.familyName}}</td>
            <td style="text-align: center;vertical-align: middle;width:5%;">
              <mat-checkbox #inputEl (change)="add(m, inputEl);" [checked]="m.checked"></mat-checkbox>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-sm-12">
      <mat-expansion-panel *ngIf="members.length > 0" [expanded]=true class="accordionmargin">
        <mat-expansion-panel-header [expandedHeight]="'48px'">
          <mat-panel-title>
            Lägg till nedanstående medlemmar
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <table class="table table-bordered table-striped table-hover" style="width: 96%;">
          <thead role="rowgroup">
            <tr>
              <th>Medlemsnr</th>
              <th>Förnamn</th>
              <th>Efternamn</th>
              <th>Ort</th>
            </tr>
          </thead>
          <tr *ngFor="let m of members">
            <td class="test" style="width:80px;">{{m.id}}</td>
            <td class="test" style="width:150px;">{{m.givenName}}</td>
            <td class="test" style="width:150px;">{{m.familyName}}</td>
            <td class="test" style="width:150px;">{{m.homeCity}}</td>
          </tr>
        </table>
        <button class="btn border" (click)="saveNewMembers()" [disabled]="!form.valid">Spara</button>
      </mat-expansion-panel>
    </div>
  </div>
</div>